module.exports = __webpack_public_path__ + "static/img/04.4d2700f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news21/04.png
// module id = 3Ayt
// module chunks = 1